export const STATUS_LIST_ALL = 'ALL'
export const STATUS_LIST_WAITING_TRANSFER = 'WaitForRecharge'
export const STATUS_LIST_TRANSFER = 'Recharged'
export const STATUS_LIST_SAVED = 'Pending'
export const STATUS_LIST_CANCEL = 'Cancel'

export const UPDATE_STATUS_MODAL = 'UPDATE_STATUS_MODAL'
export const DETAIL_MODAL = 'DETAIL_MODAL'
